<template>
    <img v-if="full" alt="Logo" :src="fullLogo"/>
    <img v-else alt="Logo" :src="squareLogo"/>
</template>

<script setup>
import { useUserStore } from "@/store/user.js";
import { storeToRefs } from "pinia";
import { computed } from "vue";
import inQrLogo from "/public/img/logo.svg";
import inQrLogoFull from "/public/img/logo-full.svg";
import {useRegisterStore} from "@/store/register.js";

const props = defineProps({
    full: Boolean,
});

const userStore = useUserStore();
const registerStore = useRegisterStore();

const { user } = storeToRefs(userStore);
const { registerKey } = storeToRefs(registerStore);

const agencyObject = computed(() => {
    if (user.value && user.value.agency) {
        return user.value.agency;
    }

    if (registerKey.value) {
        return registerKey.value.agency
    }

    return null;
});

const fullLogo = computed(() => {
    return agencyObject.value?.logo || inQrLogoFull;
});

const squareLogo = computed(() => {
    return agencyObject.value?.logo_square || inQrLogo;
});
</script>
